<template>
  <h2 class="pb-2 border-bottom">General Primary Care Services</h2>
  <ul>
    <li>Routine Checkups & Preventive Care</li>
    <li>Annual physical exams</li>
    <li>Wellness visits</li>
    <li>Vaccinations & immunizations</li>
    <li>Health screenings (blood pressure, cholesterol, diabetes, etc.)</li>
    <li>Chronic Disease Management</li>
    <li>Diabetes management</li>
    <li>Hypertension control</li>
    <li>Thyroid disorders</li>
    <li>High cholesterol</li>
    <li>Obesity and weight management</li>
    <li>Acute Care & Sick Visits</li>
    <li>Cold, flu, and infections</li>
    <li>Minor injuries and wound care</li>
    <li>Allergies and asthma care</li>
    <li>Headaches and migraines</li>
    <li>Women’s Health</li>
    <li>Hormone replacement therapy (HRT)</li>
    <li>Birth control counseling</li>
    <li>Menopause management</li>
    <li>PCOS and thyroid care</li>
    <li>Men’s Health</li>
    <li>Testosterone replacement therapy (TRT)</li>
    <li>Prostate health screening</li>
    <li>Erectile dysfunction treatment</li>
    <li>Mental Health & Behavioral Care</li>
    <li>Anxiety and depression management</li>
    <li>ADHD assessment and treatment</li>
    <li>Sleep disorder management</li>
    <li>Weight Loss & Metabolic Health</li>
    <li>Medical weight loss programs</li>
    <li>Prescription weight loss medications</li>
    <li>Nutritional counseling</li>
  </ul>
  <h2 class="pb-2 border-bottom">Additional Services We Might Offer</h2>
  <ul>
    <li>Telemedicine Consultations</li>
    <li>IV Therapy & Vitamin Infusions</li>
    <li>Dermatology & Skin Care (Acne, rashes, mole removals)</li>
    <li>Sexual Health Services (STD testing, hormone therapy)</li>
    <li>Smoking Cessation Programs</li>
  </ul>
</template>

<script>
export default {
  name: 'ContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
